<header class="mcl_header--wrapper">
  <div class="container">
    <div class="mcl_header--inner">
      <div class="mcl_header--logo">
        <img src="../../../assets/img/logo.png" class="img-fluid" alt="Logo" />
      </div>
    </div>
  </div>
</header>

<main>
  <section class="deleteForm--wrapper">
    <div class="container">
      <div class="row">
        <div class="deleteForm--inner">
          <div class="form_logo">
            <img src="../../../assets/img/logo.png" class="img-fluid" alt="Logo" />
          </div>
          <div class="mcl_title">
            <h5>Request for Account Deletion</h5>
          </div>

          <form [formGroup]="deleteForm" (ngSubmit)="onSubmit()" novalidate>
            <div class="row">
              <div class="col-md-6 offset-md-3">
                <div class="col-md-12">
                  <label>Select user type</label>
                  <select class="form-select" formControlName="role">
                    <option value="Customer">Customer</option>
                    <option value="Driver">Driver</option>
                  </select>
                </div>

                <div class="col-md-12 mt-3">
                  <label>Enter your registered email or phone number</label>
                  <input type="text" class="form-control" formControlName="email" [class.is-invalid]="
                      deleteForm.get('email')?.invalid &&
                      deleteForm.get('email')?.touched
                    " placeholder="Your Email/Phone" />
                  <div *ngIf="
                      deleteForm.get('email')?.invalid &&
                      deleteForm.get('email')?.touched
                    " class="text-danger">
                    Email is required.
                  </div>
                </div>
                <div class="col-md-12 mt-3">
                  <label>Enter your password here.</label>
                  <input type="text" class="form-control" formControlName="password" [class.is-invalid]="
                      deleteForm.get('password')?.invalid &&
                      deleteForm.get('password')?.touched
                    " placeholder="Your Password" />
                  <div *ngIf="
                      deleteForm.get('password')?.invalid &&
                      deleteForm.get('password')?.touched
                    " class="text-danger">
                    Password is required.
                  </div>
                </div>
                  <!-- New Select for Removal Request Reason -->
                  <div class="col-md-12 mt-3">
                    <label>Select Removal Request Reason</label>
                    <select class="form-select" formControlName="removalReason" required>
                      <option value="" disabled selected>Select a reason</option>
                      <option value="Misunderstanding">Misunderstanding</option>
                      <option value="No longer needed">No longer needed</option>
                      <option value="Privacy concerns">Privacy concerns</option>
                      <option value="Found a better alternative">Found a better alternative</option>
                      <option value="Other">Other</option>
                    </select>
                    <div
                      *ngIf="
                        deleteForm.get('removalReason')?.invalid &&
                        deleteForm.get('removalReason')?.touched
                      "
                      class="text-danger"
                    >
                      Removal reason is required.
                    </div>
                  </div>

                <div class="col-md-12 mt-4">
                  <button type="submit" class="btn btn-style" [disabled]="isSubmitting">
                    {{ isSubmitting ? "Submitting..." : "Submit" }}
                  </button>
                  <!-- <app-confirm-deletion-request-user></app-confirm-deletion-request-user> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</main>

<footer class="mcl_footer">
  <div class="mcl_footerBootom">
    <div class="mcl_copright">
      <p>© Copyright 2024 by Wooffer. All Rights Reserved.</p>
    </div>
  </div>
</footer>